import { render, staticRenderFns } from "./App.vue?vue&type=template&id=31fdd36a"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=31fdd36a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_n3acbem2au4l2e3t4qvos3rwwq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports